import { render, staticRenderFns } from "./RiskProcedure.vue?vue&type=template&id=64e03412"
import script from "./RiskProcedure.vue?vue&type=script&lang=js"
export * from "./RiskProcedure.vue?vue&type=script&lang=js"
import style0 from "./RiskProcedure.vue?vue&type=style&index=0&id=64e03412&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports